import { render } from "./PostStatsModal.vue?vue&type=template&id=21e5ef86&scoped=true"
import script from "./PostStatsModal.vue?vue&type=script&lang=js"
export * from "./PostStatsModal.vue?vue&type=script&lang=js"

import "./post-stats-modal.scss?vue&type=style&index=0&id=21e5ef86&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e5ef86"]])

export default __exports__